import { guideSteps, communityRules } from "@/mocks/gossip";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-accent-700">
            <i className="ri-compass-3-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            入门与规则
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">吃瓜入门四步走 & 社区规则</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            第一次来不知道从哪开始？按下面的四步走一遍，很快就能融入吃瓜群众的行列。同时请遵守社区规则，让围观现场保持清爽。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <ol className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {guideSteps.map((step) => (
                <li key={step.step} className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5">
                  <span className="font-heading text-2xl font-bold text-primary-300">{step.step}</span>
                  <div className="min-w-0">
                    <h3 className="text-sm md:text-base font-medium text-foreground-950">{step.title}</h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <aside className="rounded-lg border border-background-200 bg-secondary-50 p-5">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-8 h-8 rounded-md bg-secondary-100 text-secondary-800">
                <i className="ri-shield-user-line text-base" aria-hidden="true"></i>
              </span>
              <h3 className="text-sm font-medium text-secondary-900">社区公约</h3>
            </div>
            <ul className="mt-4 space-y-3">
              {communityRules.map((rule, index) => (
                <li key={index} className="flex gap-2.5 text-xs leading-relaxed text-secondary-900/90">
                  <i className="ri-check-line w-4 h-4 mt-0.5 shrink-0 flex items-center justify-center text-secondary-600" aria-hidden="true"></i>
                  <span>{rule}</span>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}